import steem from 'steem';
import { STEEM_API } from '../config';

steem.api.setOptions({ url: STEEM_API });

export default steem;
